import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode"; // Correct import

export default function PublicRoutes({ children }) {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      return;
    }

    try {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 > Date.now()) {
        navigate("/dashboard", { replace: true });
        return;
      }
    } catch (error) {
      console.error("Invalid token:", error);
    }

    localStorage.clear();
  }, [navigate, token]);

  return <div>{children}</div>;
}
